import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import InformationFrame from "../../../common/components/InfomationFrame/InformationFrame";
import { useAppDispatch, useAppSelector } from "../../../common/state/hooks";
import { getPublishWarningText } from "../../alert/state/alertsSlice";
import {
  getCurrentProjectGroupBuilds,
  resetNewPublicationState,
} from "../../builds/state/buildsSlice";
import PublishNewVersion from "./PublishNewVersion";
import PublishWhileThereIsAnExistingBuild from "./PublishWhileThereIsAnExistingBuild";
import { Outlet, useLocation } from "react-router-dom";

export default function AskPublicationWrapper() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const path = location.pathname.split("/");
  const lastUrlElement = path[path.length - 1];
  const hasResetForThisPath = useRef<string | null>(null);

  const currentProjectGroupBuilds = useAppSelector(getCurrentProjectGroupBuilds);
  const publishWarningText = useAppSelector(getPublishWarningText);

  // Reset publication state ONLY when first entering /publish/new
  // Use ref to prevent React Strict Mode from resetting twice
  useEffect(() => {
    if (lastUrlElement === "new" && hasResetForThisPath.current !== lastUrlElement) {
      dispatch(resetNewPublicationState());
      hasResetForThisPath.current = lastUrlElement;
    }
  }, [lastUrlElement, dispatch]);

  const smartTitle = location.pathname.includes("publish/new/platforms")
    ? t("pages.projectGroup.publish.sameVersion")
    : location.pathname.includes("publish/new/version")
    ? t("pages.projectGroup.publish.newVersion")
    : "";

  return (
    <div className="flex flex-col align-center items-center h-full">
      {publishWarningText ? (
        <InformationFrame
          className="w-full px-6 max-w-6xl mx-auto z-50 transition-opacity z-[100]"
          style="warning"
          withTimeout={false}
          showCloseButton={false}
        >
          <span>{publishWarningText}</span>
        </InformationFrame>
      ) : null}
      <h2 className="mx-4 font-medium text-2xl">
        {`${t("pages.projectGroup.publish.newPublication")} ${smartTitle}`}
      </h2>
      <Outlet />
      {lastUrlElement === "new" &&
        (currentProjectGroupBuilds.length === 0 ||
        currentProjectGroupBuilds.every(
          (b) =>
            !b.project_group_snapshot_sorted_by_order?.published_projects ||
            b.project_group_snapshot_sorted_by_order.published_projects.length === 0,
        ) ? (
          <PublishNewVersion />
        ) : (
          <PublishWhileThereIsAnExistingBuild />
        ))}
    </div>
  );
}
